import { render, staticRenderFns } from "./credit-note-table.vue?vue&type=template&id=00122e11&scoped=true&"
import script from "./credit-note-table.vue?vue&type=script&lang=js&"
export * from "./credit-note-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00122e11",
  null
  
)

export default component.exports